import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ICON_REGISTRY_PROVIDER } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { TourNgxBootstrapModule } from 'ngx-ui-tour-ngx-bootstrap';
import {
  BannerComponent,
  CopyTextComponent,
  CustomFooterComponent,
  DepositAccountComponent,
  GeolocationComponent,
  NavigationComponent,
  IconModule,
} from 'src/components/common';
import { BuyingPowerSecureAmountComponent } from 'src/components/common/buyingPowerSecureAmount/buyingPowerSecureAmount.component';
import { CopyButtonComponent } from 'src/components/common/copy-button/copy-button.component';
import { DatetimeRangePickerComponent } from 'src/components/common/datetime-range-picker/datetime-range-picker.component';
import { DayTradesInfoComponent } from 'src/components/common/dayTradesInfo/dayTradesInfo.component';
import { DoubleSellingComponent } from 'src/components/common/double-selling/double-selling.component';
import { ExplorerCompatibilityComponent } from 'src/components/common/explorerCompatibility/explorerCompatibility.component';
import { MaintenanceModeComponent } from 'src/components/common/maintenanceMode/maintenanceMode.component';
import { TabComponent } from 'src/components/common/tabs/tab.component';
import { TabsComponent } from 'src/components/common/tabs/tabs.component';
import { TermsAndConditionsGlobalComponent } from 'src/components/common/terms-and-conditions-global/terms-and-conditions-global.component';
import { TermsAndConditionsComponent } from 'src/components/common/termsAndConditions/termsAndConditions.component';
import { TooltipComponent } from 'src/components/common/tooltip/tooltip.component';
import { AdvisorSearchComponent } from 'src/components/contracts/AdvisorSearch/advisorSearch.component';
import { ContractsComboComponent } from 'src/components/contracts/contractsCombo/contractsCombo.component';
import { ContractsSearchComponent } from 'src/components/contracts/contractsSearch/contractsSearch.component';
import { NotFundedModalComponent } from 'src/components/contracts/not-funded-modal/not-funded-modal.component';
import { StrategyEditionComponent } from 'src/components/contracts/strategyEdition/strategyEdition.component';
import { LoaderComponent } from 'src/components/loader/loader';
import { ForeignExchangeComponent } from 'src/components/market/foreignExchange/foreignexchange.component';
import { IndexesComponent } from 'src/components/market/indexes/indexes.component';
import { EconomicDataComponent } from 'src/components/market/issueDetail/economicData/economicData.component';
import { FactsComponent } from 'src/components/market/issueDetail/facts/facts.component';
import { IssueDetailTitleComponent } from 'src/components/market/issueDetail/issue-detail-title.component';
import { IssueDetailComponent } from 'src/components/market/issueDetail/issueDetail.component';
import { ParticipationComponent } from 'src/components/market/issueDetail/participation/participation.component';
import { SimpleDetailListComponent } from 'src/components/market/simple-detail-list/simple-detail-list.component';
import { TopTenComponent } from 'src/components/market/topTen/topTen.component';
import { TopTenDetailComponent } from 'src/components/market/topTen/topTenDetail/topTenDetail.component';
import { PriceAlertsComponent } from 'src/components/price-alerts/price-alerts.component';
import { ModalOverlayModule } from 'src/components/shared/modal-overlay/modal-overlay.module';
import { ChatMenuComponent } from 'src/components/shared/chat-menu/chat-menu.component';
import { WhatsappChatComponent } from 'src/components/shared/whatsapp-chat/whatsapp-chat.component';
import { CollapsibleGridComponent } from 'src/components/shared/collapsible-grid/collapsible-grid.component';
import { ComboSelectComponent } from 'src/components/shared/comboSelect/comboSelect.component';
import { FullModalComponent } from 'src/components/shared/full-modal/full-modal.component';
import { InputMoneyComponent } from 'src/components/shared/input-money/input-money.component';
import { MarketFooterBarComponent } from 'src/components/shared/market-footer-bar/market-footer-bar.component';
import { NewsItemComponent } from 'src/components/shared/news/news-item/news-item.component';
import { NewsComponent } from 'src/components/shared/news/news.component';
import { NoSpecialCharacterDirective } from 'src/components/shared/NoSpecialCharacterDirectiva/NoSpecialCharacterDirective.directive';
import { NumberOnlyModule } from 'src/core/directives/onlyNumbers/onlyNumber.modules';
import { PunchPickerDirective } from 'src/components/shared/punchpicker/punchpicker.directive';
import { SearchBoxComponent } from 'src/components/shared/search-box/search-box.component';
import { UjetChatComponent } from 'src/components/shared/ujet-chat/ujetChat.component';
import { SideModalModule } from 'src/components/side-modal/side-modal.module';
import {
  BlotterCapitalsComponent,
  BlotterCashComponent,
  BlotterComponent,
  BlotterFundsComponent,
  PosturasComponent,
  TradeBarComponent,
  TradeCapitalsComponent,
  TradeCashComponent,
  TradeFundsComponent,
  TransactionsCashComponent,
} from 'src/components/trade';

import { ConfirmationModalComponent } from 'src/components/trade/tradeBar/components/confirmation-modal/confirmation-modal.component';
import { DayTradeComponent } from 'src/components/trade/tradeBar/components/day-trade/day-trade.component';
import {
  EnLineaOrderComponent,
  LimitadaOrderComponent,
  MPLActivaOrderComponent,
  MPLPasivaOrderComponent,
  MPLVolumenOcultoComponent,
  OneCancelAnotherOrderComponent,
  OneTriggersAnotherOrderComponent,
  StopEnLineaOrderComponent,
  StopLimitadoOrderComponent,
  TrailingStopOrderComponent,
  UsaOrderComponent,
  VentaEnCortoOrderComponent,
} from 'src/components/trade/tradeBar/components/ordersType';
import { TradeTransferComponent } from 'src/components/trade/tradeBar/components/transfer/tradeTransfer.component';
import { BalanceActionsComponent } from 'src/components/trade/tradeBar/containers/balance-actions/balance-actions.component';
import { InactivityDetectorComponent } from 'src/shared/inactivity-detector/inactivityDetector.component';
import { PipesModule } from 'src/shared/pipes';
import { DynamicComponentDirective } from '../dynamic-component-loader/dynamic-component.directive';
import { UserIsLockedComponent } from '../login/components/userIsLocked.component';
import { DayTradesDetailComponent } from '../subContainers/orders/components/day-trades-detail/day-trades-detail.component';
import { MainContainerComponent } from './components/mainContainer.component';
import { UpgradeModalComponent } from './components/upgrade-modal/upgrade-modal.component';
import { LineChartModule } from 'src/components/shared/line-chart/line-chart.module';
import { NgClickOutsideModule } from 'ng-click-outside2';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    NgClickOutsideModule,
  ],
  declarations: [SearchBoxComponent],
  exports: [SearchBoxComponent],
})
export class GlobalComponentsModule {}

// tslint:disable-next-line: max-classes-per-file
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    PipesModule,
    TourNgxBootstrapModule,
    IconModule,
    SideModalModule,
    NgClickOutsideModule,
  ],
  exports: [
    ComboSelectComponent,
    CopyTextComponent,
    FullModalComponent,
    TabsComponent,
    TabComponent,
    DatetimeRangePickerComponent,
    CollapsibleGridComponent,
    DayTradesInfoComponent,
    DoubleSellingComponent,
    BuyingPowerSecureAmountComponent,
    CopyButtonComponent,
  ],
  declarations: [
    ComboSelectComponent,
    CopyTextComponent,
    FullModalComponent,
    TabsComponent,
    TabComponent,
    DatetimeRangePickerComponent,
    CollapsibleGridComponent,
    DayTradesInfoComponent,
    DoubleSellingComponent,
    BuyingPowerSecureAmountComponent,
    CopyButtonComponent,
  ],
})
export class M4Module {}

// tslint:disable-next-line: max-classes-per-file
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    MatDatepickerModule,
    MatInputModule,
    M4Module,
    GlobalComponentsModule,
    SideModalModule,
    NgClickOutsideModule,
  ],
  exports: [
    TopTenComponent,
    TransactionsCashComponent,
    BlotterComponent,
    TooltipComponent,
    BlotterCapitalsComponent,
    BlotterFundsComponent,
    BlotterCashComponent,
    IssueDetailComponent,
    IssueDetailTitleComponent,
    TopTenDetailComponent,
    EconomicDataComponent,
    FactsComponent,
    ParticipationComponent,
    SimpleDetailListComponent,
    DayTradesDetailComponent,
    NewsComponent,
    NewsItemComponent,
  ],
  declarations: [
    TopTenComponent,
    TransactionsCashComponent,
    BlotterComponent,
    TooltipComponent,
    BlotterCapitalsComponent,
    BlotterFundsComponent,
    BlotterCashComponent,
    IssueDetailComponent,
    IssueDetailTitleComponent,
    TopTenDetailComponent,
    EconomicDataComponent,
    FactsComponent,
    ParticipationComponent,
    SimpleDetailListComponent,
    DayTradesDetailComponent,
    NewsComponent,
    NewsItemComponent,
  ],
  providers: [],
})
export class M3Module {}

// tslint:disable-next-line: max-classes-per-file
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    LineChartModule,
    ModalOverlayModule,
    IconModule,
  ],
  exports: [IndexesComponent, ForeignExchangeComponent],
  declarations: [IndexesComponent, ForeignExchangeComponent],
  providers: [ICON_REGISTRY_PROVIDER],
})
export class M1Module {}

// tslint:disable-next-line: max-classes-per-file
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    M1Module,
    M3Module,
    M4Module,
    NumberOnlyModule,
    TourNgxBootstrapModule,
    NgxMaskModule.forRoot({}),
    SideModalModule,
    NgClickOutsideModule,
  ],
  exports: [
    NavigationComponent,
    BannerComponent,
    ContractsComboComponent,
    ContractsSearchComponent,
    AdvisorSearchComponent,
    StrategyEditionComponent,
    GeolocationComponent,
    NotFundedModalComponent,

    // MAIN SCREEN
    CustomFooterComponent,
    ChatMenuComponent,
    WhatsappChatComponent,
    InactivityDetectorComponent,
    UjetChatComponent,
    MarketFooterBarComponent,
  ],
  declarations: [
    NavigationComponent,
    BannerComponent,
    ContractsComboComponent,
    ContractsSearchComponent,
    AdvisorSearchComponent,
    StrategyEditionComponent,
    GeolocationComponent,
    NotFundedModalComponent,

    // MAIN SCREEN
    CustomFooterComponent,
    ChatMenuComponent,
    WhatsappChatComponent,
    InactivityDetectorComponent,
    UjetChatComponent,
    MarketFooterBarComponent,
  ],
  providers: [],
})
export class NavModule {}

// tslint:disable-next-line: max-classes-per-file
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    M4Module,
    NumberOnlyModule,
    M3Module,
    TourNgxBootstrapModule,
    NgxMaskModule.forRoot({}),
    GlobalComponentsModule,
    SideModalModule,
    NgClickOutsideModule,
  ],
  exports: [
    TradeBarComponent,
    TradeCapitalsComponent,
    TradeFundsComponent,
    TradeCashComponent,
    PosturasComponent,
    PunchPickerDirective,
    InputMoneyComponent,
    NoSpecialCharacterDirective,
    LimitadaOrderComponent,
    UsaOrderComponent,
    EnLineaOrderComponent,
    MPLActivaOrderComponent,
    MPLPasivaOrderComponent,
    MPLVolumenOcultoComponent,
    OneCancelAnotherOrderComponent,
    OneTriggersAnotherOrderComponent,
    StopEnLineaOrderComponent,
    StopLimitadoOrderComponent,
    TrailingStopOrderComponent,
    VentaEnCortoOrderComponent,
    TradeTransferComponent,
    DepositAccountComponent,
    BalanceActionsComponent,
    PriceAlertsComponent,
    ConfirmationModalComponent,
    DayTradeComponent,
  ],
  declarations: [
    TradeBarComponent,
    TradeCapitalsComponent,
    TradeFundsComponent,
    TradeCashComponent,
    PosturasComponent,
    PunchPickerDirective,
    InputMoneyComponent,
    NoSpecialCharacterDirective,
    LimitadaOrderComponent,
    UsaOrderComponent,
    EnLineaOrderComponent,
    MPLActivaOrderComponent,
    MPLPasivaOrderComponent,
    MPLVolumenOcultoComponent,
    OneCancelAnotherOrderComponent,
    OneTriggersAnotherOrderComponent,
    StopEnLineaOrderComponent,
    StopLimitadoOrderComponent,
    TrailingStopOrderComponent,
    VentaEnCortoOrderComponent,
    TradeTransferComponent,
    DepositAccountComponent,
    BalanceActionsComponent,
    PriceAlertsComponent,
    ConfirmationModalComponent,
    DayTradeComponent,
  ],
  providers: [],
})
export class OperationPuppetModule {}

// tslint:disable-next-line: max-classes-per-file
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    NavModule,
    OperationPuppetModule,
    ModalOverlayModule,
    IconModule,
  ],
  exports: [TermsAndConditionsComponent, TermsAndConditionsComponent],
  declarations: [
    MainContainerComponent,
    UserIsLockedComponent,
    DynamicComponentDirective,
    TermsAndConditionsComponent,
    TermsAndConditionsGlobalComponent,
    LoaderComponent,
    ExplorerCompatibilityComponent,
    MaintenanceModeComponent,
    UpgradeModalComponent,
  ],
  providers: [],
})
export class RootModule {}
